if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        // Dawn rechnete hier mit activeMedia.width — das gibt es an einem div nicht,
        // der Wert war immer NaN und landete als 0. Auf dem Handy liegen die Bilder
        // jetzt nebeneinander, deshalb wird die Spalte des angeklickten Bildes
        // gemessen und angefahren. Steht nur ein Bild in der Reihe, ist der Wert 0
        // und das Verhalten bleibt wie bisher.
        container.scrollLeft = this.offsetOf(container, activeMedia);
        this.updateCounter();

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }

      // Abstand eines Kindes zum linken Innenrand seines Scrollcontainers,
      // unabhaengig davon, welches Element gerade offsetParent ist.
      offsetOf(container, child) {
        return child.getBoundingClientRect().left - container.getBoundingClientRect().left + container.scrollLeft;
      }

      // Zaehler der Wischgalerie. Beim Oeffnen einmal setzen und danach dem
      // Scrollen folgen. Gemessen wird bei jedem Aufruf frisch, weil der Inhalt
      // des Modals bei einem Variantenwechsel neu gerendert wird.
      updateCounter() {
        this.renderCounter();
        if (this.counterBound) return;

        const container = this.querySelector('[role="document"]');
        if (!container) return;
        this.counterBound = true;
        container.addEventListener('scroll', () => {
          window.clearTimeout(this.counterTimer);
          this.counterTimer = window.setTimeout(this.renderCounter.bind(this), 60);
        });

        // Knoepfe Zurueck/Weiter. Dawns ModalDialog schliesst ein Medien-Modal bei
        // jedem pointerup einer Maus; die Leiste haelt das von ihren Knoepfen fern.
        const nav = this.querySelector('.cal-media-modal__nav');
        if (nav) {
          nav.addEventListener('pointerup', (event) => event.stopPropagation());
          nav.querySelectorAll('[data-cal-modal-step]').forEach((button) => {
            button.addEventListener('click', () => this.step(Number(button.dataset.calModalStep)));
          });
        }

        // Pfeiltasten blaettern, solange die Wischgalerie aktiv ist (Handy)
        this.addEventListener('keydown', (event) => {
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          if (!this.isSwipeGallery(container)) return;
          event.preventDefault();
          this.step(event.key === 'ArrowRight' ? 1 : -1);
        });
      }

      // Nur mobil liegen die Bilder nebeneinander; am Schreibtisch stapelt Dawn
      // sie untereinander, dort gibt es seitlich nichts zu blaettern.
      isSwipeGallery(container) {
        return container.scrollWidth > container.clientWidth + 1;
      }

      currentIndex(container, slides) {
        const middle = container.scrollLeft + container.clientWidth / 2;
        const current = slides.findIndex((slide) => this.offsetOf(container, slide) + slide.offsetWidth > middle);
        return current < 0 ? slides.length - 1 : current;
      }

      // Waehrend ein weiches Scrollen noch laeuft, zaehlt das Ziel des letzten
      // Tipps als aktuelles Bild, sonst ginge ein schneller zweiter Tipp verloren.
      // renderCounter setzt das Ziel zurueck, sobald das Scrollen steht.
      step(direction) {
        const container = this.querySelector('[role="document"]');
        if (!container) return;
        const slides = Array.from(container.children);
        const from = this.targetIndex ?? this.currentIndex(container, slides);
        const index = from + direction;
        const target = slides[index];
        if (!target) return;
        this.targetIndex = index;

        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        container.scrollTo({ left: this.offsetOf(container, target), behavior: reduceMotion ? 'auto' : 'smooth' });
      }

      renderCounter() {
        const indexEl = this.querySelector('[data-cal-modal-index]');
        const totalEl = this.querySelector('[data-cal-modal-total]');
        const container = this.querySelector('[role="document"]');
        if (!indexEl || !totalEl || !container) return;

        const slides = Array.from(container.children);
        const current = this.currentIndex(container, slides);
        this.targetIndex = null;
        totalEl.textContent = slides.length;
        indexEl.textContent = current + 1;

        const prev = this.querySelector('[data-cal-modal-step="-1"]');
        const next = this.querySelector('[data-cal-modal-step="1"]');
        if (!prev || !next) return;
        const focused = document.activeElement;
        prev.disabled = current <= 0;
        next.disabled = current >= slides.length - 1;
        // Ein gesperrter Knopf verliert den Fokus, er fiele aus dem Dialog und
        // Esc griffe nicht mehr. Dann geht der Fokus auf den anderen Knopf.
        if (focused === prev && prev.disabled) next.focus();
        if (focused === next && next.disabled) prev.focus();
      }
    }
  );
}
